import { List } from 'immutable';

export const selectComboUpsells = (state, sectionProductId) =>
  state.getIn(['comboUpsells', 'upsellSectionProducts', String(sectionProductId)], List());

export const selectComboUpsellsHaveBeenFetched = (state, sectionProductId) => {
  const map = state.getIn(['comboUpsells', 'upsellSectionProducts']);
  if (!map || typeof map.has !== 'function') return false;
  return map.has(String(sectionProductId));
};

export const selectComboUpsellsLoading = state =>
  Boolean(state.getIn(['comboUpsells', 'loadingComboUpsells'], false));

export const selectComboUpsellsError = state =>
  Boolean(state.getIn(['comboUpsells', 'errorLoadingComboUpsells'], false));
